import api from "..";

export const fetchEmployees = (params = {}, callBack) => {
    api.get(`/company-structure/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const inviteMemberInCompany = (id, data, callBack) => {
    api.post(`/company-structure/${id}/add-member/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const deleteMembers = (id, data, callBack) => {
    api.delete(`/company-structure/${id}/delete-member/`, {
        data: data,
    })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};



export const getTeamHierarchy = (id, callBack) => {
    api.get(`/companies/${id}`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const updateHierarchy = (id, data, callBack) => {
    api.put(`/companies/${id}/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const inviteMembersOfDiffTeam = (id, data, callBack) => {
    api.post(`/invite-team-member/${id}/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const acceptInvitationOnMemberEnd = (token, callBack) => {
    api.post(`/accept-team-invitation/${token}/`, {})
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};




